import React from "react";

const UserDetailsTable = ({
  name,
  email,
  phone,
  npi,
  // subscription,
  infoProvided,
  organization,
}) => {
  const tableRowClass = "border-b border-grey h-14";
  const propertyCellClass = "pl-0.5 md:pl-8 font-medium";
  const dataCellClass = "text-right md:text-left pr-0.5 md:pr-0 font-normal";

  return (
    <table className="table-auto md:table-fixed w-full">
      <tbody className="font-rubik text-base">
        <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>Name</td>
          <td className={`${dataCellClass}`}>{name}</td>
        </tr>
        <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>Email</td>
          <td className={`${dataCellClass}`}>{email}</td>
        </tr>
        <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>Phone</td>
          <td
            className={`${dataCellClass} ${
              !infoProvided && "text-disable-grey"
            }`}
          >
            {phone}
          </td>
        </tr>
        <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>NPI</td>
          <td className={`${dataCellClass}`}>{npi}</td>
        </tr>
        {/* <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>Subscription</td>
          <td className={`${dataCellClass}`}>{subscription}</td>
        </tr> */}
        <tr className={`${tableRowClass}`}>
          <td className={`${propertyCellClass}`}>Organization</td>
          <td className={`${dataCellClass}`}>{organization}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default UserDetailsTable;
